import { render } from "./ScoreBoard.vue?vue&type=template&id=dcb10af4&scoped=true"
import script from "./ScoreBoard.vue?vue&type=script&lang=js"
export * from "./ScoreBoard.vue?vue&type=script&lang=js"

import "./ScoreBoard.vue?vue&type=style&index=0&id=dcb10af4&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcb10af4"]])

export default __exports__